import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useToast } from '@/components/ui/use-toast';
import { LabelGroup } from '@/features/label/types';
import { label } from '@/utils/label';

const QUERY_KEY = 'active-year';

export const updateYear = (newYear: number): Promise<void> => {
  return axios.put(`/year/${newYear}`);
};

type UseOptions = {
  config?: MutationConfig<typeof updateYear>;
};

export const useUpdateYear = ({ config }: UseOptions) => {
  const { toast } = useToast();

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEY]);
      queryClient.refetchQueries([QUERY_KEY]);

      toast({
        variant: 'success',
        title: label('year_updated_successfully', LabelGroup.ADMIN_SETTINGS),
      });
    },
    ...config,
    mutationFn: updateYear,
  });
};
